import BaseService from "./BaseService";

export default class FXReportsService extends BaseService {
    public static getReportDetails(token: string, postData: any, reportName: string, forCSV: boolean = false) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}fxAllocation/${reportName}${forCSV ? 'CSVData' : 'Report'}`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        }, undefined, forCSV)
    }
}